import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppContextService {
  hasGyms = false;
  onlyCommunityClubs = false;
  hasCommunityClubs = false;
  communityClubLogoUrl: string | null = null;

  setCommunityClubs(clubs: Array<{ s3LogoUrl?: string | null }>): void {
    this.hasCommunityClubs = clubs.length > 0;
    this.onlyCommunityClubs = !this.hasGyms && this.hasCommunityClubs;
    this.communityClubLogoUrl = this.hasCommunityClubs
      ? (clubs[0]?.s3LogoUrl ?? null)
      : null;
  }
}
